import { useQuery } from '@tanstack/react-query';

import { useCurrentActor } from 'components/contexts/CurrentActor';

export default function useTrackedPersonnel() {
  const currentActor = useCurrentActor();

  const { trackedPersonnelAllowance } = currentActor.subscription.attributes;
  const { accessType } = currentActor.user.attributes;

  const isEnabled =
    accessType !== 'personnel' && trackedPersonnelAllowance !== null;

  const {
    data: trackedPersonnelUsageReport,
    isSuccess: isTrackedPersonnelUsageReportSuccess,
  } = useQuery({
    enabled: isEnabled,
    queryKey: ['personnel', 'trackedUsageReport'],
    queryFn: async () => {
      const response = await axios.post('/personnel/tracked_usage_reports');
      return response.data;
    },
  });

  const trackedPersonnelUsage =
    isEnabled && trackedPersonnelUsageReport ?
      trackedPersonnelUsageReport.data.attributes.count
    : null;

  const hasReachedTrackedPersonnelUsageThreshold =
    isEnabled &&
    trackedPersonnelAllowance !== 0 &&
    isTrackedPersonnelUsageReportSuccess &&
    trackedPersonnelUsage / trackedPersonnelAllowance >= 0.8;

  const hasReachedTrackedPersonnelLimit =
    isEnabled &&
    isTrackedPersonnelUsageReportSuccess &&
    trackedPersonnelUsage >= trackedPersonnelAllowance;

  const isTrackedPersonnelUsageLoaded =
    isTrackedPersonnelUsageReportSuccess || !isEnabled;

  return {
    hasReachedTrackedPersonnelLimit,
    hasReachedTrackedPersonnelUsageThreshold,
    isTrackedPersonnelUsageLoaded,
    trackedPersonnelAllowance,
    trackedPersonnelUsage,
  };
}
